/* VCTparts info pages (sections/vct-page-*.liquid).
   - Live Feedback Company score in [data-vct-ip-fc]: the same summary and
     session cache as snippets/vct-feedback-bar.liquid (the Feedback Company
     API key stays in the Worker, never in the theme).
   - Videos load only after a click ([data-vct-ip-video]), from
     youtube-nocookie.com, so no YouTube request or cookie before consent.
   - Policy pages (.vct-policy, see snippets/vct-policy-nav.liquid): a table
     of contents from the headings, the print button, and wide tables that
     scroll sideways on small screens. */
(function () {
  'use strict';

  var FC_URL = 'https://vct-reviews.henkherrebout.workers.dev/reviews.json';
  var FC_CACHE = 'vct-fc-summary';

  function fillScore(summary) {
    var score = summary && Number(summary.score);
    var count = summary && Number(summary.count) || 0;
    document.querySelectorAll('[data-vct-ip-fc]').forEach(function (box) {
      var locale = box.getAttribute('data-locale') || document.documentElement.lang || 'nl-NL';
      if (!score) { box.classList.add('is-fallback'); return; }
      box.querySelectorAll('[data-vct-ip-fc-score]').forEach(function (el) {
        el.textContent = score.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) +
          (el.hasAttribute('data-bare') ? '' : '/10');
      });
      box.querySelectorAll('[data-vct-ip-fc-count]').forEach(function (el) {
        if (count) el.textContent = count.toLocaleString(locale);
        else if (el.closest('[data-vct-ip-fc-count-wrap]')) el.closest('[data-vct-ip-fc-count-wrap]').hidden = true;
      });
      box.querySelectorAll('[data-vct-ip-fc-stars]').forEach(function (el) {
        el.style.width = Math.max(0, Math.min(100, score * 10)) + '%';
      });
      box.classList.add('is-loaded');
    });
  }

  function loadScore() {
    if (!document.querySelector('[data-vct-ip-fc]')) return;
    // Same source and cache as the review tab (layout/theme.liquid)
    if (window.vctFcSummary) {
      window.vctFcSummary().then(fillScore, function () { fillScore(null); });
      return;
    }
    try {
      var cached = JSON.parse(sessionStorage.getItem(FC_CACHE) || 'null');
      if (cached && cached.score) return fillScore(cached);
    } catch (e) {}
    fetch(FC_URL, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var summary = data && data.summary;
        if (summary && summary.score) {
          try { sessionStorage.setItem(FC_CACHE, JSON.stringify({ score: summary.score, count: summary.count })); } catch (e) {}
        }
        fillScore(summary);
      })
      .catch(function () { fillScore(null); });
  }

  function initVideos() {
    document.querySelectorAll('[data-vct-ip-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-vct-ip-video');
        if (!/^[\w-]{6,20}$/.test(id)) return;
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        frame.title = btn.getAttribute('aria-label') || 'Video';
        frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        frame.allowFullscreen = true;
        var wrap = document.createElement('div');
        wrap.className = 'vct-ip-video';
        wrap.appendChild(frame);
        btn.replaceWith(wrap);
      }, { once: true });
    });
  }

  function slug(text) {
    return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'deel';
  }

  function initPolicy() {
    var wrap = document.querySelector('.vct-policy');
    var body = wrap && wrap.querySelector('.shopify-policy__body');
    if (!body) return;
    var head = wrap.querySelector('.vct-policy__head');

    // The current policy in the row of links (and in view on phones)
    var pills = wrap.querySelector('.vct-policy__nav ul');
    var active = pills && pills.querySelector('[aria-current="page"]');
    if (pills && !active) {
      var here = location.pathname.split('/').pop();
      pills.querySelectorAll('a').forEach(function (a) {
        if (!active && a.pathname.split('/').pop() === here) { active = a; a.setAttribute('aria-current', 'page'); }
      });
    }
    if (active && pills.scrollWidth > pills.clientWidth) {
      pills.scrollLeft += active.getBoundingClientRect().left - pills.getBoundingClientRect().left - 16;
    }

    wrap.querySelectorAll('[data-vct-print]').forEach(function (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () { window.print(); });
    });

    body.querySelectorAll('table').forEach(function (table) {
      if (table.parentNode.classList.contains('vct-policy__table')) return;
      var box = document.createElement('div');
      box.className = 'vct-policy__table';
      table.parentNode.insertBefore(box, table);
      box.appendChild(table);
    });

    // Table of contents: the highest heading level with at least three
    // headings (h2 in the privacy policy, h3 articles in the terms).
    var level = ['h2', 'h3'].filter(function (tag) { return body.querySelectorAll(tag).length >= 3; })[0];
    if (!level) return;
    var label = (head && head.getAttribute('data-toc-label')) || 'Inhoud';
    var list = document.createElement('ol');
    body.querySelectorAll(level).forEach(function (h, i) {
      var text = h.textContent.replace(/\s+/g, ' ').trim().replace(/[:.]$/, '');
      if (!text) return;
      if (!h.id) {
        var id = 'p-' + slug(text);
        if (document.getElementById(id)) id += '-' + i;
        h.id = id;
      }
      var link = document.createElement('a');
      link.href = '#' + h.id;
      // "Artikel 6 - Herroepingsrecht" reads as "6. Herroepingsrecht" in the list
      link.textContent = text.replace(/^(artikel|article|art\.)\s*(\d+)\s*[-–—:.]\s*/i, '$2. ');
      var item = document.createElement('li');
      item.appendChild(link);
      list.appendChild(item);
    });
    if (list.children.length < 3) return;

    var toc = document.createElement('nav');
    toc.className = 'vct-policy__toc';
    toc.setAttribute('aria-label', label);
    var details = document.createElement('details');
    var summary = document.createElement('summary');
    summary.textContent = label;
    details.appendChild(summary);
    details.appendChild(list);
    toc.appendChild(details);
    var print = head && head.querySelector('[data-vct-print]');
    if (print) toc.appendChild(print);
    body.parentNode.insertBefore(toc, body);
    wrap.classList.add('has-toc');

    // Wide screens: the list stays open beside the text; small screens: a
    // closed "Inhoud" button above the text.
    var wide = window.matchMedia('(min-width: 1000px)');
    var sync = function () { details.open = wide.matches; };
    sync();
    if (wide.addEventListener) wide.addEventListener('change', sync);
    summary.addEventListener('click', function (e) { if (wide.matches) e.preventDefault(); });
    list.addEventListener('click', function (e) {
      if (e.target.closest('a') && !wide.matches) details.open = false;
    });

    // Mark the part in view: the last heading that has passed the top
    var links = {};
    list.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var heads = [].filter.call(body.querySelectorAll(level), function (h) { return links[h.id]; });
    var current = null;
    var ticking = false;
    function mark() {
      ticking = false;
      var inView = heads[0];
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top < 160) inView = heads[i];
        else break;
      }
      var a = inView && links[inView.id];
      if (!a || a === current) return;
      if (current) current.removeAttribute('aria-current');
      a.setAttribute('aria-current', 'true');
      current = a;
      // keep it visible when the list itself scrolls (long terms)
      var box = toc.getBoundingClientRect();
      var r = a.getBoundingClientRect();
      if (toc.scrollHeight > toc.clientHeight && (r.bottom > box.bottom || r.top < box.top)) {
        toc.scrollTop += r.top - box.top - box.height / 3;
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(mark); }
    }, { passive: true });
    mark();
  }

  function init() { loadScore(); initVideos(); initPolicy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
